import React, { useState } from "react";

const ContactUsForm = ({ setShowForm }) => {
  const [isVisible, setIsVisible] = useState(true);

  const handleCancelClick = () => {
    setIsVisible(false);
    setShowForm(false);
  };

  if (!isVisible) return null;

  return (
    <div className="form_main_container">
      <div className="form_and_icon_wrapper">
        <svg
          className="cancel_icon"
          xmlns="http://www.w3.org/2000/svg"
          width="2rem"
          height="2rem"
          viewBox="0 0 512 512"
          onClick={handleCancelClick}
        >
          <rect width="512" height="512" fill="none" />
          <path
            fill="white"
            fillRule="evenodd"
            d="M420.48 121.813L390.187 91.52L256 225.92L121.813 91.52L91.52 121.813L225.92 256L91.52 390.187l30.293 30.293L256 286.08l134.187 134.4l30.293-30.293L286.08 256z"
          />
        </svg>
        <div className="form_container">
          <div className="form_title_and_content">
            <h2 className="form_title">Welcome to LogoLab</h2>
            {/* <p className="form_content">
              Please fill up this form and we'll get to you. This is some text
              which will be changed soon.
            </p> */}
          </div>
          <div className="form_labels_and_inputs">
            <div className="contact_and_address">
              <div className="full_name">
                <h4>Full Name</h4>
                <input type="text" placeholder="Fullname" />
              </div>

              <div className="address">
                <h4>Address</h4>
                <input type="text" placeholder="Address" />
              </div>
            </div>

            <div className="contact_and_address">
              <div className="contact">
                <h4>Contact No.</h4>
                <input type="tel" placeholder="Contact no." />
              </div>
              <div className="services">
                <h4>Services</h4>
                <select name="services" id="sevices">
                  <option value="Option1">Option 1</option>
                  <option value="Option2">Option 2</option>
                  <option value="Option3">Option 3</option>
                  <option value="Option4">Option 4</option>
                </select>
              </div>
            </div>

            <div className="message">
              <h4>Message</h4>
              <textarea placeholder="Enter your message" />
            </div>

            <div className="note">
              <h4>Note:</h4>
              <textarea placeholder="Note" />
            </div>
          </div>

          <button className="form_button">Sign Up</button>
        </div>
      </div>
    </div>
  );
};

export default ContactUsForm;
